import QuestionViewVisual from "./QuestionViewVisual";
import QuestionViewVerbal from "./QuestionViewVerbal";

export default class QuestionViewRotatedShape extends QuestionViewVerbal{
    constructor(question) {
        super(question);

        let image = new PIXI.mesh.NineSlicePlane(P3.assets.texture("answer_box_9slice"), 0, 20, 0, 20);
        image.width = 300;
        image.height = 275;
        image.pivot.set(image.width * 0.5, image.height * 0.5);
        this.addChild(image);

        let image2 = new PIXI.mesh.NineSlicePlane(P3.assets.texture("answer_box_9slice"), 0, 20, 0, 20);
        image2.width = 300;
        image2.height = 275;
        image2.pivot.set(image2.width * 0.5, image2.height * 0.5);
        this.addChild(image2);


        this._normalShape = new PIXI.Sprite(P3.assets.texture(question.answer.texture));
        this._normalShape.position.set(-this._normalShape.width, 340);
        this._normalShape.anchor.set(0.5);
        this.addChild(this._normalShape);

        this._rotatedShape = new PIXI.Sprite(P3.assets.texture(question.answer.texture));
        this._rotatedShape.position.set(this._rotatedShape.width, 340);
        this._rotatedShape.anchor.set(0.5);
        this._rotatedShape.rotation = question.answer.value * PIXI.DEG_TO_RAD;
        this.addChild(this._rotatedShape);

        image.position.set(this._normalShape.x, this._normalShape.y);
        image2.position.set(this._rotatedShape.x, this._rotatedShape.y);
    }

    filterTemplate(x){
        return true;
    }

    initInputField() {
        super.initInputField();
        const unitLabel = new PIXI.Text('°', {fontSize: 40, fontFamily: "BBC Reith Sans", fontWeight: "bold"});
        unitLabel.anchor.set(0, 0.5);
        unitLabel.resolution = 2;
        unitLabel.position.set(this._inputField.width * 0.5, -20);
        this._inputField.addChild(unitLabel);
    }
}